import { FC, useEffect, useState } from 'react';
import { Avatar, Button, Col, Row } from 'antd';
import { TbArrowLeft, TbCube3dSphere } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { centerComponentInMiddleofView } from '@/utilities';

interface WorkspaceResourceNotAvailableProps {
    resourceType?: string;
    previousRoute?: string;
}

const WorkspaceResourceNotAvailable: FC<WorkspaceResourceNotAvailableProps> = ({
    resourceType,
    previousRoute,
}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const navigate = useNavigate();

    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                height: '100%',
                ...centerComponentInMiddleofView,
                overflow: 'hidden',
                backgroundImage: `radial-gradient(
                    circle at 0.75rem 0.75rem,
                    ${token.colorBorder} 0.125rem,
                    transparent 0
                    )`,
                backgroundSize: '1.5rem 1.5rem',
            }}
        >
            <div
                style={{
                    backgroundColor: token.colorBgContainer,
                    border: `1px solid ${token.colorBorder}`,
                    borderRadius: token.borderRadius * 1.5,
                    textAlign: 'center',
                    padding: '2.5rem',
                    boxShadow: token.boxShadow,
                }}
            >
                <Avatar
                    shape='square'
                    icon={
                        <TbCube3dSphere
                            size='67.5%'
                            style={{ verticalAlign: '-0.1rem', color: token.colorTextTertiary }}
                        />
                    }
                    size={16 * 2.5}
                    style={{ border: `1px solid ${token.colorBorder}`, marginBottom: '0.25rem' }}
                />
                <div style={{ margin: '0.5rem 0', color: token.colorTextSecondary, fontWeight: 500 }}>
                    {resourceType ?? 'Workspace Resource'} Not Available
                </div>
                <div style={{ width: '12.5rem', margin: '0 auto', textAlign: 'center' }}>
                    <small style={{ color: token.colorTextTertiary }}>
                        It may have been deleted, or you may not have permission to view it.
                    </small>
                </div>
                <Row gutter={[8, 0]} wrap={false} align='middle' style={{ marginTop: '1rem' }}>
                    <Col flex='none'>
                        <Button type='primary' onClick={() => navigate(previousRoute ?? '/')}>
                            <TbArrowLeft size='1rem' />
                            Back to Previous View
                        </Button>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default WorkspaceResourceNotAvailable;
